export const PAYPAL_PURCHASE_STORAGE = 'paypal_purchase_storage';

export const IS_CL_COUPON_SHOWED_SENT_STORAGE_KEY = 'isCLCouponShowedSent';
